module.exports = __webpack_public_path__ + "img/card_bg_osago_small.2cf8cae.png";